/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Your_OwnInputs */

const en_create_your_own = /** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Your Own`)
};

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const es_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const fr_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const de_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const ja_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const zh_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const ar_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const id_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const it_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const ru_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const pt_create_your_own = en_create_your_own;

/** @type {(inputs: Create_Your_OwnInputs) => LocalizedString} */
const ko_create_your_own = en_create_your_own;

/**
* | output |
* | --- |
* | "Create Your Own" |
*
* @param {Create_Your_OwnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_your_own = /** @type {((inputs?: Create_Your_OwnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Your_OwnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_your_own(inputs)
	if (locale === "es") return es_create_your_own(inputs)
	if (locale === "fr") return fr_create_your_own(inputs)
	if (locale === "de") return de_create_your_own(inputs)
	if (locale === "ja") return ja_create_your_own(inputs)
	if (locale === "zh") return zh_create_your_own(inputs)
	if (locale === "ar") return ar_create_your_own(inputs)
	if (locale === "id") return id_create_your_own(inputs)
	if (locale === "it") return it_create_your_own(inputs)
	if (locale === "ru") return ru_create_your_own(inputs)
	if (locale === "pt") return pt_create_your_own(inputs)
	return ko_create_your_own(inputs)
});